import { Link } from 'react-router-dom';
import { useAccountData } from '../hooks/useAccountData';
import { PersonalInfoSection, AddressSection, B2BOrgSection } from '../components/account/ProfileSections';
import AddressesSection from '../components/account/AddressesSection';
import OrdersSection from '../components/account/OrdersSection';
import PasswordChangeSection from '../components/account/PasswordChangeSection';
import EmailChangeSection from '../components/account/EmailChangeSection';

export default function Account() {
  const {
    user, authLoading, account, loading, saving,
    personalForm, setPersonalForm, addressForm, setAddressForm,
    savePersonal, saveAddress,
    isB2B, profile, b2bPerson, b2bOrg, orders,
  } = useAccountData();

  if (authLoading || loading) return (
    <div className="max-w-3xl mx-auto px-6 py-12"><div className="w-8 h-8 border-4 border-muted border-t-primary rounded-full animate-spin mx-auto" /></div>
  );

  if (!user) return null;

  if (!loading && !account && user) {
    return (
      <div className="max-w-3xl mx-auto px-6 md:px-12 py-24 text-center">
        <p className="font-serif text-xl text-muted-foreground mb-4">Sessie verlopen</p>
        <p className="text-sm text-muted-foreground mb-6">Uw sessie is verlopen. Log opnieuw in om uw account te bekijken.</p>
        <Link to="/login" className="text-sm text-primary font-medium hover:underline">Opnieuw inloggen</Link>
      </div>
    );
  }

  return (
    <div data-testid="account-page" className="max-w-3xl mx-auto px-6 md:px-12 py-12">
      <div className="mb-10">
        <h1 className="font-serif text-4xl font-light text-foreground mb-1">Mijn account</h1>
        <p className="text-muted-foreground">{user.name || user.email}</p>
        <div className="w-10 h-px bg-accent mt-4" />
      </div>

      <PersonalInfoSection user={user} personalForm={personalForm} setPersonalForm={setPersonalForm} saving={saving} onSave={savePersonal} />

      {isB2B ? (
        <B2BOrgSection b2bPerson={b2bPerson} b2bOrg={b2bOrg} />
      ) : (
        <AddressSection profile={profile || {}} addressForm={addressForm} setAddressForm={setAddressForm} saving={saving} onSave={saveAddress} />
      )}

      <AddressesSection />

      <OrdersSection orders={orders} />

      <PasswordChangeSection />

      <EmailChangeSection user={user} />
    </div>
  );
}
